import React from "react";
import styled from 'styled-components';
import { variables, devices, colors } from "../../assets/styles/variables";
import { Container } from "../Core/Container";
import { Button, Logo } from "../Core";
import { P, SMALL } from "../Core/Typography";
import { Link } from "gatsby";

const Wrapper = styled.div`
    padding: 45px 0px;
    background-color: ${colors.black};

    hr {
        opacity: 1;
        border-top: 1px solid ${colors.white};
        &.hr-mobile { display: none; }
        &.hr-desktop { display: block; }
    }

    .auto-width {
        width: 266px !important;
    }

    @media (max-width: ${devices.sizeLaptop}) {
        hr {
            &.hr-mobile { display: block; }
            &.hr-desktop { display: none; }
        }
    }
`;

const Grid = styled.div`
    .row > * { padding: 0px !important; margin: 0px !important; }
    .slide {
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        p {
            color: ${colors.primary} !important;
            text-transform: uppercase;
            text-align: center;
            font-size: ${variables.bannerTitleSize};
            line-height: ${variables.bannerTitleLine};
            font-weight: ${variables.bannerTitleWeight};
        } 
        small {
            color: ${colors.white} !important;
            font-size: ${variables.footerSmallSize};
            line-height: ${variables.footerSmallLine};
            font-weight: ${variables.footerSmallWeight};
        } 
    }

    @media (max-width: ${devices.sizeTablet}) {
        .slide {
            p {
                font-size: ${variables.bannerTitleSize};
                line-height: ${variables.bannerTitleLine};
                font-weight: ${variables.bannerTitleWeight};
            } 
            small {
                font-size: ${variables.mobileFooterSmallSize};
                line-height: ${variables.mobileFooterSmallLine};
                font-weight: ${variables.mobileFooterSmallWeight};
            } 
        }
    }
`;

const TitleStyled = styled.div`
    margin-bottom: 20px;
    letter-spacing: -0.5px;
    font-size: ${variables.footerHeadingSize};
    line-height: ${variables.footerHeadingLine};
    font-weight: ${variables.footerHeadingWeight};
    color: ${colors.white};
    @media (max-width: ${devices.sizeLaptop}) {
        font-size: ${variables.mobileFooterHeadingSize};
        line-height: ${variables.mobileFooterHeadingLine};
        font-weight: ${variables.mobileFooterHeadingWeight};
    }
`;

const UlStyled = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    .white-text {
        color: ${colors.white} !important;
    }
    .icon {
        color: ${colors.white} !important;
    }
    li {
        line-height: ${variables.footerLinkLine};
        a {
            font-size: ${variables.footerLinkSize};
            line-height: ${variables.footerLinkLine};
            font-weight: ${variables.footerLinkWeight};
            color: ${colors.white} !important;
            @media (max-width: ${devices.sizeLaptop}) {
                font-size: ${variables.mobileFooterLinkSize};
                line-height: ${variables.mobileFooterLinkLine};
                font-weight: ${variables.mobileFooterLinkWeight};
            }

            &:hover {
                text-decoration: none;
                color: ${colors.lightGrey2} !important;
            }
        }
    }
`;

const year = new Date().getFullYear();

const SocialIcons = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;

    a {
        color: #ffffff !important;
        font-size: 25px;
        transition: 0.4s;
        padding: 0 3px;
        margin: 0 2.5px;

        &:visited {
            text-decoration: none;
        }

      &:hover {
        text-decoration: none;
        color: #ffffff !important;

        .path1:before {
          color: #ffffff !important;
          transition: 0.4s;
        }
      }

      .path1:before {
        color: rgba(255, 255, 255, 1) !important;
        transition: 0.4s;
      }
    }
`;

const Footer = ({ isDark = false }) => {
    return (
        <>
        <Wrapper>
        <Container className="text-center minh-415">
            <Grid className="ph-25">
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-xl-4 col-xxl-4 slide d-flex flex-column justify-content-start align-items-center align-items-md-center align-items-xl-start">
                    <Logo auto white />
                    <p className="mt-15 mb-30">Where the most <br />powerful <br />internet lives.</p>
                </div>
                <div className="col-6 col-sm-6 col-md-3 col-xl-2 col-xxl-2 slide">
                    <TitleStyled>Company</TitleStyled>
                    <UlStyled className="mb-30">
                        <li>
                            <Link to="/wholesale/">
                                Wholesale
                            </Link>
                        </li>
                        <li>
                            <Link to="/rollout/">
                                Rollout
                            </Link>
                        </li>
                        <li>
                            <Link to="/about-us/">
                                About us
                            </Link>
                        </li>
                        <li>
                            <Link to="/team/">
                                Meet the team
                            </Link>
                        </li>
                        <li>
                            <Link to="/legal/">
                                Legal
                            </Link>
                        </li>
                    </UlStyled>
                </div>
                <div className="col-6 col-sm-6 col-md-3 col-xl-2 col-xxl-2 slide">
                    <TitleStyled >
                        Useful links
                    </TitleStyled>
                    <UlStyled className="mb-30">
                        <li>
                            <Link to="/broadband/">
                                Broadband
                            </Link>
                        </li>
                        <li>
                            <Link to="/careers/">
                                Careers
                            </Link>
                        </li>
                        <li>
                            <Link to="/areas/">
                                Areas
                            </Link>
                        </li>
                        <li>
                            <Link to="/support/">
                                Support
                            </Link>
                        </li>
                    </UlStyled>
                </div>
                <div className="col-6 col-sm-6 col-md-3 col-xl-3 col-xxl-3 slide">
                    <TitleStyled >
                        Brand resources
                    </TitleStyled>
                    <UlStyled className="mb-30">
                        <li>
                            <a href="/netomnia_logo_set.zip" download>
                                Netomnia logo
                            </a>
                        </li>
                        <li>
                            <a href="/netomnia_brand_guidelines_v3.pdf" download>
                                Netomnia brand guidelines
                            </a>
                        </li>
                    </UlStyled>
                </div>
                <div className="col-6 col-sm-6 col-md-3 col-xl-1 col-xxl-1 slide">
                    <TitleStyled >
                        Follow us
                    </TitleStyled>
                    <SocialIcons>
                        <a href="https://www.facebook.com/netomnia" target="_blank" rel="noreferrer">
                            <i className="icon icon-logo-facebook"></i>
                        </a>
                        <a href="https://twitter.com/netomnia" target="_blank" rel="noreferrer">
                            <i className="icon iconn-twitter-x-seeklogocom-4-2">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </a>
                        <a href="https://www.linkedin.com/company/netomnia" target="_blank" rel="noreferrer">
                            <i className="icon icon-logo-linkedin"></i>
                        </a>
                        <a href="https://www.youtube.com/@Netomnia" target="_blank" rel="noreferrer">
                            <i className="fab fa-youtube" style={{color: '#ffffff', marginBottom: '11px'}}></i>
                        </a>
                    </SocialIcons>
                </div>
            </div>
            </Grid>
                <hr className="hr-mobile" />
        </Container>
        <hr className="hr-desktop" />
        <Container>
            <Grid className="ph-25">
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-xl-8 col-xxl-8 slide d-flex flex-column justify-content-center align-items-center align-items-center align-items-md-center align-items-xl-start text-center text-md-left">
                    <SMALL className="mv-10">167-169 Great Portland Street, 5th Floor, London, W1W 5PF, United Kingdom</SMALL>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-xl-4 col-xxl-4 slide d-flex flex-column justify-content-center align-items-center align-items-center align-items-md-center align-items-xl-end text-center text-md-right">
                    <SMALL className="mv-10">© {year} Netomnia, All Rights Reserved.</SMALL>
                </div>
            </div>
            </Grid>
        </Container>
        </Wrapper>
        </>
    )
};

export default Footer;
